module.exports = __webpack_public_path__ + "img/title5.70e2d311.png";